export interface IConversationBaseProps {
  id: number | string;
}
/**
 * For any type of message:
 * Lead and Review by now
 */
export interface IMessageBaseProps {
  id: number | string;
  senderName: string;
  message: string;
  createTime: string;
  source: MessageSource;
}

/**
 * Superclass for any type of message:
 * Lead and Review by now
 */
export class MessageBaseModel implements IMessageBaseProps {
  id: number | string;
  senderName: string;
  message: string;
  createTime: string;
  source: MessageSource;
  constructor(data: IMessageBaseProps) {
    this.id = data.id;
    this.senderName = data.senderName;
    this.message = data.message;
    this.createTime = data.createTime;
    this.source = data.source;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type MESSAGE_TYPE = 'ALL' | 'READ' | 'NEW' | 'CHATS' | 'MESSAGES';
// export type MESSAGE_SOURCE = 'EMAIL' | 'GBM_MESSAGES' | 'GMB_REVIEW' | 'CHAT_WEBSITE' | 'UNKNOWN';

export enum MessageSource {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  EMAIL = 'EMAIL',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GBM_MESSAGES = 'GBM_MESSAGES',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GMB_REVIEW = 'GMB_REVIEW',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CHAT_WEBSITE = 'CHAT_WEBSITE',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  //UNKNOWN = 'UNKNOWN',
}

export const MESSAGE_SOURCES_METADATA: {
  [key in MessageSource]: {
    title: string;
    iconSrc: string;
    iconOpenSrc?: string;
  };
} = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  EMAIL: {
    title: 'MESSAGES_MODULE.SOURCES.EMAIL',
    iconSrc: 'Icon_BoxListWebMail.svg',
    iconOpenSrc: 'Icon_MessagesBoxEmail.svg',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GBM_MESSAGES: {
    title: 'MESSAGES_MODULE.SOURCES.GBM_MESSAGES',
    iconSrc: 'Icon_BoxListGoogleB.svg',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GMB_REVIEW: {
    title: 'MESSAGES_MODULE.SOURCES.GMB_REVIEW',
    iconSrc: 'Icon_BoxListGoogleB.svg',
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CHAT_WEBSITE: {
    title: 'MESSAGES_MODULE.SOURCES.CHAT_WEBSITE',
    iconSrc: 'Icon_BoxListWebChat.svg',
  }
};
